import { useEffect, useState } from 'react';

import { isPensionParameter } from '@fora-monorepo/employer-my-pages-common/utils';
import { Box, ContentDisclosure, Flex, Headings, Line } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../../i18n/i18n';
import { FokParameterFormProps } from './types';
import { ActiveParameter } from './ActiveParameter';
import { ParameterCheckboxOld, PensionParameterCheckboxOld } from './ParameterCheckboxOld';

export const FokParameterForm = ({
  activeParameters,
  availableParameters,
  setParameterChoicesInput,
  disabled = false,
  employmentStartDate,
  fokParameterValidity,
  formType,
}: FokParameterFormProps) => {
  const { t } = useTypedTranslation();
  useEffect(() => {
    setParameterChoicesInput(prevList =>
      prevList.filter(
        ({ fokParameter: prevP }) =>
          activeParameters?.some(activeP => prevP.parameterValue === activeP.parameterValue) ||
          availableParameters?.some(availableP => prevP.parameterValue === availableP.parameterValue)
      )
    );
    // Update the form data state when any of activeParameters, fokParameters are changed,
    // so that for example if a new markup is selected and SAFLO65 is not available anymore, it is removed from the data state
  }, [activeParameters, availableParameters, setParameterChoicesInput]);

  const [hasCheckedBox, setHasCheckedBox] = useState(false);

  if (
    (!activeParameters || activeParameters.length === 0) &&
    (!availableParameters || availableParameters.length === 0)
  ) {
    return null;
  }

  const hasActiveParameters = activeParameters && activeParameters.length > 0;

  return (
    <Box marginTop={40}>
      <ContentDisclosure
        titleClose={t('common.close')}
        titleOpen={t('form.parameter.expandLink')}
        initiallyExpanded={hasActiveParameters}
        hideClose={hasActiveParameters || hasCheckedBox}
      >
        <Line color="black20" marginBottom={20} />
        <Headings.H5 marginBottom={10} marginTop={10} color={disabled ? 'black70' : undefined}>
          {t('form.parameter.title')}
        </Headings.H5>
        <Flex flexDirection="column" rowGap={12}>
          {hasActiveParameters &&
            activeParameters.map((parameter, i) => (
              <ActiveParameter
                key={i}
                setParameterChoicesInput={setParameterChoicesInput}
                employmentStartDate={employmentStartDate}
                activeParameterChoice={parameter}
                fokParameterValidity={fokParameterValidity}
                disabled={disabled}
              />
            ))}
          {availableParameters?.map((parameter, i) =>
            isPensionParameter(parameter.parameterValue) ? (
              <PensionParameterCheckboxOld
                key={i}
                fokParameter={parameter}
                setParameterChoicesInput={setParameterChoicesInput}
                disabled={disabled}
                fokParameterValidity={fokParameterValidity}
                setHasCheckedBox={setHasCheckedBox}
                formType={formType}
                employmentStartDate={employmentStartDate}
              />
            ) : (
              <ParameterCheckboxOld
                key={i}
                fokParameter={parameter}
                fokParameterValidity={fokParameterValidity}
                setParameterChoicesInput={setParameterChoicesInput}
                disabled={disabled}
                employmentStartDate={employmentStartDate}
                setHasCheckedBox={setHasCheckedBox}
                formType={formType}
              />
            )
          )}
        </Flex>
      </ContentDisclosure>
    </Box>
  );
};
